<template>
<div id="ganadores">

  <section id = "intro">
    <div class = "container">
      <h1> Proyectos 2018-2019</h1>
      <project-video-player />
      <p class="is-size-6"> <a href="https://vimeo.com/376363469" target="_blank">Video con todos los proyectos </a> </p>
      <p class="is-size-6"> <a href="https://vimeo.com/376353227" target="_blank">Video acelerado con todos los proyectos en 5 minutos </a> </p>

      <p style="margin-top:2em">
        Este año hemos recibido proyectos de gran calidad y de diversa procedencia.
        Tenemos tres categorías. Una para los participantes que están cursando una enseñanza de Secundaria o Bachillerato.
        Otra categoría para módulos profesionales y universidad y una última para los que se han presentado por libre.
      </p>
      <h1> Los favoritos</h1>

        <div class = "loading-wrapper" v-if = "state.gallery.isLoading">
          <b-loading :is-full-page="false" :active.sync="state.gallery.isLoading" :can-cancel="false"></b-loading>
        </div>

        <div v-else >
          <h2> Secundaria  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.secundaria, tags_hardcoded.p5)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h2> Módulos y Universidad  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.fpuni, tags_hardcoded.p5)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h2> Por Libre  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.libre, tags_hardcoded.p5)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h1> Otros proyectos que nos han gustado </h1>
          <p>
            Además de los proyectos top, en un segundo escalón del podium también hemos elegido otros envíos que nos parecen reseñables.
          </p>
          <h2> Secundaria  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.secundaria, tags_hardcoded.p4)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h2> Módulos y Universidad  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.fpuni, tags_hardcoded.p4)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h2> Por Libre  </h2>
          <div class = "gallery-items">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.libre, tags_hardcoded.p4)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>

          <h1> Además ... </h1>
          Y aquí dejamos otros que también nos han gustado
          <div class = "gallery-items smaller">
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.secundaria, tags_hardcoded.p3)" :key = "item.id" :galleryItem = "item"></gallery-item>
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.fpuni, tags_hardcoded.p3)" :key = "item.id" :galleryItem = "item"></gallery-item>
            <gallery-item v-for = "item in galleryItemsFiltered(tags_hardcoded.libre, tags_hardcoded.p3)" :key = "item.id" :galleryItem = "item"></gallery-item>
          </div>
          <p>
           <router-link :to="{ name: 'Gallery'}"> Puedes consultar todos los proyectos recibidos en la Galería</router-link>
          </p>

        </div>

    </div>
  </section>

</div>
</template>

<script>
import Logo from '../UI/Logo'
import GalleryItem from '../Gallery/GalleryItem'
import ProjectVideoPlayer from './ProjectVideoPlayer'
export default {
  name: 'Ganadores2019',
  components: {
    Logo,
    GalleryItem,
    ProjectVideoPlayer
  },
  data: () => ({
    searchParams: {
      page: 1,
      call: '15',
      tags: [20, 21, 19],
      limit: 300,
      is_finished: true,
      is_example: false,
      is_public: true,
      codeAnalysis: {}
    },
    tags_hardcoded: {
      secundaria: 11,
      fpuni: 12,
      libre: 13,
      p0: 16,
      p1: 17,
      p2: 18,
      p3: 19,
      p4: 20,
      p5: 21

    }
  }),
  watch: {
  },
  computed: {
    galleryItems () {
      return this.$store.state.gallery.fetched
    },
    state () {
      return this.$store.state
    }
  },
  methods: {
    loadAllElements: function () {
      // console.log('--> ' + this.$route.params.page)

      let query = {
        params: this.searchParams
      }
      // console.log(query)
      this.$store.dispatch('fetchProjectList', query)
    },
    galleryItemsFiltered (cat, rating) {
      if (this.galleryItems && this.galleryItems.results) {
        return this.galleryItems.results.filter((e) => { return e.tags.includes(cat) && e.tags.includes(rating) })
      } else return []
    }
  },
  created () {
    this.loadAllElements()
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

#ganadores {
  padding-top: 50px;
  font-size: 1.2em;

  .container {
    padding: 30px 20px;
  }
}

h1, h2, h3 {
  font-family: 'Share Tech';
}

h1 {
  line-height: 1.3em;
  text-decoration-line: underline;
  text-decoration-color: @accentColor;
  font-size: 2.5rem;
  margin-bottom: 20px;
  text-align: center;
  margin-top:4rem;
}

h2 {
  color: @accentColor;
  font-weight: 600;
  margin-top:4rem;
  text-align: center;
  margin-bottom:2rem;
  font-size:3rem;
}

p {
  margin-bottom: 0.5em;
  line-height: 1.6em;
}

ul {
  border-left: 3px solid #2fe67c;
  padding-left: 10px;
}

iframe {
  width: 100%;
  height: 500px;
  margin: 20px 0;
}

.recursos {
  background: #f0f0f0;
  padding: 20px 20px;
  border-radius: 2px;
  margin-top: 30px;
}

.flex-video {
  position: relative;
  padding-top: 25px;
  padding-bottom: 67.5%;
  height: 0;
  margin-bottom: 16px;
  overflow: hidden;
}

.flex-video.widescreen { padding-bottom: 57.25%; }
.flex-video.vimeo { padding-top: 0; }

.flex-video iframe,
.flex-video object,
.flex-video embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media only screen and (max-device-width: 800px), only screen and (device-width: 1024px) and (device-height: 600px), only screen and (width: 1280px) and (orientation: landscape), only screen and (device-width: 800px), only screen and (max-width: 767px) {
  .flex-video { padding-top: 0; }
}
</style>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

@media (max-width: @breakPoint) {
  .gallery-items {
    grid-template: ~"auto 1fr / 1fr 1fr !important";
  }

  .cover {
    height: unset !important;
  }
}

.gallery {
  background: @backgroundColor;
  // height: 100vh;

  & > * {
    padding: 10px;
  }

}

.description {
  font-size: 1.5em;
  padding: 0 15px;
  color: #8c8c8c;
}

.content {
  padding: 20px;
}

.gallery-items {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
  grid-gap: 30px;
  justify-items: center;
}
.gallery-items.smaller {
  grid-template-columns: repeat(auto-fill,minmax(160px,1fr));
  grid-gap: 20px;
}

.loading-wrapper {
  position: relative;
  height: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home/Ganadores2019.vue